import styles from '../selected-combination.module.css';
import BooleanImage from '../../BooleanImage/BooleanImage';
import { Checkbox } from '../../index';

export interface AdditionalParamsProps {
    booked?: boolean;
    corporate?: boolean;
    openEnded?: boolean;
    ifBusinessAssets?: boolean;
    fundStatus?: string;
}

const AdditionalProposedRows = ({
    corporate,
    openEnded,
    booked,
    ifBusinessAssets,
    fundStatus,
}: AdditionalParamsProps) => {
    return (
        <>
            {typeof fundStatus !== 'undefined' && (
                <div className={`${styles.proposedCheck} `}>
                    <span>{fundStatus}</span>
                </div>
            )}

            <div className={`${styles.proposedCheck} }`}>
                <Checkbox
                    label={'open-ended'}
                    value={1}
                    checked={openEnded || false}
                    useMargin={false}
                    readOnly={true}
                />
            </div>
            <div className={`${styles.proposedCheck} `}>
                <Checkbox
                    label={'corporate'}
                    value={1}
                    checked={corporate || false}
                    useMargin={false}
                    readOnly={true}
                />
            </div>
            {typeof booked !== 'undefined' && (
                <div className={`${styles.proposedCheck} `}>
                    <Checkbox
                        label={'booked at NAV'}
                        value={1}
                        checked={booked || false}
                        useMargin={false}
                        readOnly={true}
                    />
                </div>
            )}

            {typeof ifBusinessAssets !== 'undefined' && (
                <div className={`${styles.proposedCheck} `}>
                    <Checkbox
                        label={'business asset'}
                        value={1}
                        checked={ifBusinessAssets || false}
                        useMargin={false}
                        readOnly={true}
                    />
                </div>
            )}
        </>
    );
};

export default AdditionalProposedRows;
